import {HTTP} from "../_helpers/http";

export default class ConferenceApi {

    static all() {
        return HTTP.get(`/conference`)
            .then(response => response.data)
    }

    static byCurrentUser() {
        return HTTP.get(`/conference/user`)
            .then(response => response.data)
    }

    static save(conference) {
        return HTTP.post(`/conference`, conference)
            .then(response => response.data)
    }

    static delete(id) {
        return HTTP.delete(`/conference/${id}`)
            .then(response => response.data)
    }
}